import createReducer from '../utils/createReducer';
import {
  FETCH_REQUEST,
  FETCH_FAILURE,
  FETCH_SUCCESS,
} from '../constants/actions';

const initialState = {
  isFetching: false,
  isError: false,
  statusText: null,
};

export default createReducer(initialState, {
  [FETCH_REQUEST]: () => (
    Object.assign({}, initialState, {
      isFetching: true,
      isError: false,
    })
  ),
  [FETCH_SUCCESS]: state => (
    Object.assign({}, state, {
      isFetching: false,
    })
  ),
  [FETCH_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isFetching: false,
      isError: true,
      statusText: payload.statusText,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/fetchM.js